import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, LoopReturnsIntegrationResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof LoopReturnsIntegrationResponseDataSchema>>

const queryKey = ["loopReturnsIntegration"]

export const loopReturnsIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/loopreturns/configuration`)

      return response.data.data
    },
  })
}
